<template>
  <div :style="cssVars">
    <page-layout
      :noSideBar="false"
      :headerBackgroundColor="cssVars['--outcome-primary']"
    >
      <template v-slot:headerContent>
        <div class="row">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row items-center">
          <span class="headerText text-white">
            {{
              selectedOutcome
                ? "Goals & Solutions Summary for"
                : "You need to select an outcome first"
            }}
          </span>
          <sustainability-dropdown
            :model="outcome"
            class="q-ml-sm"
            :style="`width: 230px;
                      background-color: ${cssVars['--outcome-secondary']};
                      border-radius: 5px;
                      `"
            :options="outcomesList"
            :isObjects="true"
            objectKey="label"
            disable
          ></sustainability-dropdown>
        </div>
      </template>
      <template v-slot:content>
        <div class="solutionsSummary column">
          <div class="col-auto">
            <div class="row">
              <div
                class="col-auto q-pa-md"
                :style="`min-width: 365px; max-width: 365px; background: ${cssVars['--outcome-secondary']}`"
              >
                <h3 class="q-mt-none q-mb-md" :style="`color: white`">
                  Your Goals
                </h3>

                <q-virtual-scroll
                  style="height: calc(100vh - 320px)"
                  class="full-width q-pb-md"
                  :items="formattedGoals"
                >
                  <template v-slot="{ item, index }">
                    <q-card
                      flat
                      class="text-white"
                      :style="`background-color: ${cssVars['--outcome-primary']}`"
                    >
                      <q-item
                        v-if="item.basicGoals_id"
                        :key="index"
                        dense
                        clickable
                        v-ripple="{ color: 'primary' }"
                        @click="selectGoal(item, index)"
                        class="q-mb-xs q-pa-md"
                      >
                        <q-item-section>
                          <q-item-label class="goalItem_text">
                            {{ formatPreWrittenGoalText(item).normalText }}
                            <span class="text-bold">
                              {{ formatPreWrittenGoalText(item).coloredText }}
                            </span>
                          </q-item-label>
                        </q-item-section>
                      </q-item>
                      <q-item
                        v-else
                        dense
                        clickable
                        v-ripple="{ color: 'primary' }"
                        class="q-mb-xs q-pa-md"
                        @click="selectGoal(item, index)"
                      >
                        <q-item-section v-if="item.writeYourOwnGoal">
                          <q-item-label class="goalItem_text">
                            <span class="text-bold">
                              {{ item.writeYourOwnGoal }}
                            </span>
                          </q-item-label>
                        </q-item-section>
                        <q-item-section v-else>
                          <q-item-label class="goalItem_text">
                            {{
                              item.action == "Reduce" ? "Reduction" : "Increase"
                            }}
                            of
                            <span class="text-bold">
                              {{ item.sourceData.name }}
                            </span>
                            by
                            <span class="text-bold">
                              {{
                                (item.sourceData.total *
                                  item.reductionPercentage) /
                                100
                              }}
                              {{ item.sourceData.unit }}
                            </span>
                            ({{ item.action }} {{ item.reductionPercentage }}%
                            by {{ item.due_at.split("-")[0] }})
                          </q-item-label>
                        </q-item-section>
                      </q-item>
                    </q-card>
                  </template>
                </q-virtual-scroll>

                <q-btn
                  class="q-px-sm q-py-xs bg-secondary"
                  label="Back"
                  text-color="white"
                  :style="`z-index: 1; position: absolute; bottom: 12px`"
                  no-caps
                  flat
                  @click="
                    $router.push(
                      `${$route.path.split('solutionSummary')[0]}solutionWelder`
                    )
                  "
                >
                </q-btn>
              </div>
              <!-- <div > -->
              <q-scroll-area
                class="col q-pa-md"
                :style="`height: calc(100vh - 169px); background: ${cssVars['--outcome-tertiary']}`"
                :thumb-style="{
                  background: '#162c479c',
                  opacity: 1,
                  width: '8px',
                  height: '8px',
                  borderRadius: '20px',
                }"
              >
                <div class="row">
                  <div class="col-12">
                    <h3
                      class="q-my-none"
                      :style="`color: ${cssVars['--outcome-secondary']}`"
                    >
                      Your Solutions for this Goal
                    </h3>
                  </div>
                  <div class="col-12 q-pa-sm">
                    <div
                      class="row"
                      v-if="
                        selectedGoalIndex != null &&
                        formattedGoals[selectedGoalIndex]
                      "
                    >
                      <div class="col-12">
                        <q-card
                          flat
                          :style="`background: ${cssVars['--outcome-secondary']}`"
                          class="text-white q-pa-md"
                        >
                          <div
                            v-if="
                              formattedGoals[selectedGoalIndex].basicGoals_id
                            "
                          >
                            {{
                              formatPreWrittenGoalText(
                                formattedGoals[selectedGoalIndex]
                              ).normalText
                            }}
                            <span class="text-bold">
                              {{
                                formatPreWrittenGoalText(
                                  formattedGoals[selectedGoalIndex]
                                ).coloredText
                              }}
                            </span>
                          </div>
                          <div
                            v-else-if="
                              formattedGoals[selectedGoalIndex].writeYourOwnGoal
                            "
                          >
                            {{
                              formattedGoals[selectedGoalIndex].writeYourOwnGoal
                            }}
                          </div>
                          <div v-else>
                            {{
                              formattedGoals[selectedGoalIndex].action ==
                              "Reduce"
                                ? "Reduction"
                                : "Increase"
                            }}
                            of
                            <span class="text-bold">
                              {{
                                formattedGoals[selectedGoalIndex].sourceData
                                  .name
                              }}
                            </span>
                            by
                            <span class="text-bold">
                              {{
                                (formattedGoals[selectedGoalIndex].sourceData
                                  .total *
                                  formattedGoals[selectedGoalIndex]
                                    .reductionPercentage) /
                                100
                              }}
                              {{
                                formattedGoals[selectedGoalIndex].sourceData
                                  .unit
                              }}
                            </span>
                            ({{ formattedGoals[selectedGoalIndex].action }}
                            {{
                              formattedGoals[selectedGoalIndex]
                                .reductionPercentage
                            }}% by
                            {{
                              formattedGoals[selectedGoalIndex].due_at.split(
                                "-"
                              )[0]
                            }})
                          </div>
                        </q-card>
                      </div>
                      <div v-if="!goalSolutionsLoading" class="col-12 q-pa-md">
                        <div
                          v-if="goalSolutions.length > 0"
                          class="row q-col-gutter-sm"
                        >
                          <div
                            v-for="(solution, index) in goalSolutions"
                            :key="`solutionGoal_${index}`"
                            class="col-12"
                          >
                            <q-card
                              class="bg-white q-pa-md q-px-lg cursor-pointer"
                              style="font-weight: 400"
                              @click="selectSolution(solution)"
                              flat
                            >
                              {{ solution.title }}
                            </q-card>
                          </div>
                        </div>
                        <div class="row" v-else>
                          <div class="col-12">
                            <h5>
                              To weld a solution against this goal, you can
                              either
                            </h5>
                            <h5>1. Choose one from our suggested list</h5>
                            <h5>2. Find one you've saved already</h5>
                            <h5>
                              3. Search All Solutions in our solution database
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div v-else class="col-12 q-pa-md">
                        <q-skeleton type="rect" />
                      </div>
                    </div>
                  </div>
                </div>
              </q-scroll-area>

              <!-- </div> -->
            </div>
          </div>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <!-- Wrapping only one DOM element, defined by QBtn -->
        <div class="column full-height full-width sidebar">
          <div class="col-auto q-py-md q-px-lg" style="height: calc(109px)">
            <h3>Your Actions</h3>
          </div>
          <div
            class="col-auto q-px-md"
            v-if="selectedSolution != null"
            style="height: calc(100vh - 226px)"
          >
            <div class="row">
              <div class="col-12">
                <q-virtual-scroll
                  style="height: calc(100vh - 270px)"
                  class="full-width q-pb-md"
                  v-if="
                    solutionActions &&
                    solutionActions[0].ref_id == selectedSolution.id
                  "
                  :items="solutionActions"
                >
                  <template v-slot="{ item, index }">
                    <q-card flat :style="`background-color: white`">
                      <q-item
                        :key="index"
                        dense
                        clickable
                        v-ripple="{ color: 'primary' }"
                        class="q-mb-xs q-pa-md"
                      >
                        <!-- <q-item-section side>
                          <q-checkbox
                            v-model="item.status"
                            color="accent"
                            true-value="Completed"
                            false-value="New"
                          >
                          </q-checkbox>
                        </q-item-section> -->
                        <q-item-section>
                          <q-item-label class="goalItem_text">
                            {{ item.value }}
                          </q-item-label>
                        </q-item-section>
                      </q-item>
                    </q-card>
                  </template>
                </q-virtual-scroll>
              </div>
            </div>
          </div>
          <div
            class="col-auto q-px-md"
            v-else
            style="height: calc(100vh - 226px)"
          >
            <div class="row">
              <div class="col-12"></div>
              <div class="col-12">
                <q-scroll-area
                  style="height: calc(100vh - 220px)"
                  :thumb-style="{
                    background: '#162c479c',
                    opacity: 1,
                    width: '8px',
                    height: '8px',
                    borderRadius: '20px',
                  }"
                >
                  Welcome to
                  <span class="highlight">Your Sustainability Plan Preview</span
                  >. This is a summary of the previous steps and what they look
                  like. If your happy with the content of your plan, click “View
                  Full Plan” to reveal the complete version.
                  <br />
                  <br />
                  <br />
                  <span class="subtext"
                    >Click on a goal to reveal the specific solutions and
                    actions</span
                  >
                </q-scroll-area>
              </div>
            </div>
          </div>

          <div class="col q-px-md text-right">
            <q-btn
              @click="$router.push(`/fullPlan/${outcomePlan.id}`)"
              class="q-px-sm q-py-xs bg-accent col-auto"
              no-caps
              flat
            >
              <span class="text-white text"> View Full Plan </span>
            </q-btn>
          </div>
        </div>
      </template>
    </page-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageLayout from "@/components/pageLayout/pageLayout.vue";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import { getCSSVars } from "@/functions/cssVars";

export default {
  components: {
    PageLayout,
    SustainabilityDropdown,
  },
  computed: {
    ...mapGetters({
      outcomesList: "outcomes/list",
      currentUserData: "auth/currentUserData",
      selectedOutcome: "businessOutcomePlans/selectedOutcome",
      solutionsList: "solutions/sources/list",
      goals: "goals/list",
      goalSolutions: "goals/solutions/list",
      goalSolutionsLoading: "goals/solutions/listLoading",
      savedSolutions: "solutions/business/listSaved",
      savedSolutionsLoading: "solutions/business/listSavedLoading",
      solutionActions: "solutions/business/actions/list",
      outcomePlan: "businessOutcomePlans/current",
    }),
    cssVars() {
      let outcome = this.selectedOutcome;
      return getCSSVars(outcome);
    },
  },
  data: () => ({
    outcome: null,
    selectedYear: null,

    selectedQuestion: null,

    formattedGoals: [],
    selectedGoalIndex: null,

    selectedSolution: null,
  }),
  watch: {
    selectedOutcome: function () {
      this.initSelectedOutcome();
    },
    $route: {
      handler() {
        this.handleRoute();
      },
      props: true,
    },
  },
  async mounted() {
    if (this.selectedOutcome) {
      this.initSelectedOutcome();
    }
    this.selectedYear = this.$moment().format("YYYY");

    this.handleRoute();
    // this.loadData();
  },
  methods: {
    getCSSVars: getCSSVars,
    initSelectedOutcome() {
      this.outcome = this.selectedOutcome;
    },

    handleRoute() {
      if (this.$route.params.hasOwnProperty("goalID")) {
        this.goalBuilderDialog = true;
      } else if (this.$route.params.hasOwnProperty("outcomesID")) {
        this.initGoals();
      }
    },

    initGoals() {
      this.formattedGoals = [];
      this.$store
        .dispatch(
          "goals/loadAllGoalsAndBasicGoalsByOutcomeID",
          this.$route.params.outcomesID
        )
        .then(() => {
          this.formattedGoals = [];
          this.goals.forEach((e) => {
            this.formattedGoals.push({ ...e, selected: false });
          });
          this.filterGoals();
        });
    },

    selectGoal(goal, index) {
      this.selectedSolution = null;
      if (this.selectedGoalIndex == index) {
        this.formattedGoals[index].selected = false;
        this.selectedGoalIndex = null;
      } else {
        let goals = [];
        this.formattedGoals.forEach((e) => {
          if (goal.id == e.id) {
            goals.push({ ...e, selected: true });
          } else {
            goals.push({ ...e, selected: false });
          }
        });
        this.formattedGoals = goals;
        this.selectedGoalIndex = index;
        this.$store.dispatch("goals/solutions/loadAll", goal.id);
      }
    },

    filterGoals() {
      let goals = this.formattedGoals;
      if (this.sortByDropdown == "Newest") {
        goals.sort((a, b) => (a.created_at < b.created_at ? 1 : -1));
      } else {
        goals.sort((a, b) => (a.created_at > b.created_at ? 1 : -1));
      }
      this.formattedGoals = goals;
      if (this.selectedGoalIndex === null) {
        this.selectGoal(this.formattedGoals[0], 0);
      }
    },
    formatPreWrittenGoalText(goal) {
      if (goal.basicGoalAction) {
        let normalText = goal.basicGoalAction.split(goal.basicGoal);

        if (normalText.length > 0) {
          let coloredText = goal.basicGoalAction.split(normalText[0]);
          return {
            normalText: normalText[0],
            coloredText: coloredText[1],
          };
        }
      } else {
        return {
          normalText: goal.basicGoal,
          coloredText: "",
        };
      }
      let normalText = goal.basicGoalAction.split(goal.basicGoal);

      if (normalText.length > 0) {
        let coloredText = goal.basicGoalAction.split(normalText[0]);
        return {
          normalText: normalText[0],
          coloredText: coloredText[1],
        };
      }
    },

    selectSolution(solution) {
      this.selectedSolution = solution;
      this.$store.dispatch(
        "solutions/business/actions/loadAllBySolutionId",
        solution.id
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.solutionsSummary {
  h3 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 1.5rem;
    display: flex;
    align-items: center;
  }

  h5 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.1rem;
    display: flex;
    align-items: center;
    color: $accent2;
  }
}

.sidebar {
  h3 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: var(--outcome-secondary);
    margin: 10px 0px;
  }

  h4 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 800;
    font-size: 1.1rem;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }

  .highlight {
    font-weight: 800;
    color: var(--outcome-secondary);
  }

  .subtext {
    font-style: italic;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: var(--outcome-secondary);
  }
}

.headerText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}

.twoLinedButton {
  font-size: 0.8rem;
  line-height: 1rem;
  font-weight: 400;
}

.goalItem_text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
}

.goalItem_source_text {
  color: var(--outcome-primary);
}
</style>
